export enum CLUSTER_ACTION {
    REMOVE = 1,
    STATUS = 2,
}
